import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RoutineVideo } from '../../../../../models/routine-video.model';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-routine-video-cards',
  standalone: true,
  imports: [CommonModule, TranslocoDirective],
  templateUrl: './routine-video-cards.component.html',
  styleUrl: './routine-video-cards.component.scss'
})
export class RoutineVideoCardsComponent {
  @Input() videos: RoutineVideo[] = [];
  @Input() isLoading: boolean = false;

  readonly loadingPlaceholders = [0, 1];

  @Output() videoClicked = new EventEmitter<RoutineVideo>();

  onVideoClick(video: RoutineVideo): void {
    this.videoClicked.emit(video);
  }
}
